export default __webpack_public_path__ + "static/media/extra1.afc12686.png";